<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>Firma Ekle</h4>
      <v-row style="margin-top: 100px;">
        <v-col cols="12" md="4">
          <h4>Firma Adı</h4>
          <v-text-field
            v-model="company.companyName"
            maxlength="255"
            counter="255"
            :rules="companyNameRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>
        <v-col cols="12" md="4">
          <h4>Firma Segmenti</h4>
          <v-select
            v-model="company.companySegment"
            :items="segmentList"
            item-text="companySegment"
            item-value="companySegment"
            data-vv-name="select"
            required
          ></v-select>
        </v-col>
        <v-col cols="12" md="8"></v-col>
        <v-col cols="12" md="4">
          <h4>Firma Ünvan</h4>
          <v-text-field
            v-model="company.companyTitle"
            maxlength="200"
            counter="200"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>
        <v-col cols="12" md="4">
          <h4>Vergi Dairesi</h4>
          <v-text-field
            v-model="company.taxAdministration"
            maxlength="255"
            counter="255"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <h4>Vergi Kimlik No</h4>
          <v-text-field
            v-model="company.taxIdentity"
            maxlength="10"
            counter="10"
            v-mask="'##########'"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="8"></v-col>
        <v-col cols="12" md="12">
          <h4>Fatura Adresi</h4>

          <v-textarea
            v-model="company.invoiceAddress"
            maxlength="255"
            counter="255"
            rows="1"
            auto-grow
            required
          ></v-textarea>
        </v-col>
        <v-col cols="12" md="4">
          <h4>Fatura Mail Adresi</h4>
          <v-text-field
            v-model="company.invoiceMailAddress"
            maxlength="255"
            counter="255"
            :rules="
              company.invoiceMailAddress != '' &&
              company.invoiceMailAddress &&
              company.invoiceMailAddress.trim() != ''
                ? emailRules
                : ''
            "
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>
        <v-col cols="12" md="4">
          <h4>IBAN</h4>
          <v-text-field
            v-model="company.iban"
            maxlength="32"
            counter="32"
            return-masked-value
            v-mask="'TR## #### #### #### #### #### ##'"
            placeholder="TR"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <h4>Banka Adı</h4>
          <v-text-field
            v-model="company.bankName"
            maxlength="150"
            counter="150"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4"></v-col>
        <v-col cols="12" md="3">
          <h4>Yetkili Ad & Soyad</h4>
          <v-text-field
            v-model="company.executiveName"
            maxlength="250"
            counter="250"
            required
          ></v-text-field>
        </v-col>
        <!-- <v-col cols="12" md="3">s
          <h4>Yetkili Soyad</h4>
          <v-text-field v-model="company.executiveSurname" maxlength="150" counter="150"
                        required></v-text-field>
        </v-col> -->
        <v-col cols="12" md="3">
          <h4>Yetkili Ünvan</h4>
          <v-text-field
            v-model="company.executiveTitle"
            maxlength="150"
            counter="150"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <h4>Yetkili Telefon</h4>
          <v-text-field
            v-model="company.executivePhoneNumber"
            maxlength="50"
            counter="50"
            v-mask="' (###) ### ## ##'"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <h4>Aktif/Pasif</h4>
          <v-checkbox v-model="company.active" color="#4d48f9"></v-checkbox>
        </v-col>
        <v-col cols="12" md="8">
          <h4>Kahve Hacmi, Sütlü Kod ve Sütsüz Kod alanları eklensin mi?</h4>
          <v-checkbox
            v-model="company.coffeeExtras"
            color="#4d48f9"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="4">
          <h4>Status</h4>
          <v-select
            v-model="company.companyStatus"
            :items="allCompanyStatus"
            data-vv-name="select"
            item-text="name"
            item-value="value"
            @change="onCompanyStatusChange"
            required
          ></v-select>
        </v-col>

        <v-col cols="12" md="4" v-if="showSegmentStatusReason === true">
          <h4>Kapalı Olma Sebebi</h4>
          <v-select
            v-model="company.companyStatusReasonType"
            :items="allCompanyStatusReasonTypes"
            data-vv-name="select"
            item-text="name"
            item-value="value"
            required
          ></v-select>
        </v-col>

        <v-col cols="12" md="7">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important; float: right; color: white;"
            @click="companyAdd()"
          >
            EKLE
          </v-btn>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="fruit in this.errorList" :key="fruit">{{ fruit }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- <v-row>
          
      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Company',
  data: () => ({
    valid: true,
    companyNameRules: [
      (v) => !!v || 'Firma adı alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    companySegmentRules: [
      (v) => !!v || 'Firma segmenti alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 10 karakter olmalıdır.',
    ],
    companyTitleRules: [
      (v) => !!v || 'Firma ünvanı alanı zorunludur.',
      (v) => v.length <= 100 || 'Maksimum 100 karakter olmalıdır.',
    ],
    taxAdminRules: [
      (v) => !!v || 'Vergi dairesi  alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    emailRules: [
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'Lütfen geçerli bir mail adresi giriniz.',
    ],
    addressRules: [
      (v) => !!v || 'Adres alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    company: {
      companyName: '',
      companySegment: '',
      executiveName: '',
      executiveTitle: '',
      executivePhoneNumber: '',
      companyTitle: '',
      taxAdministration: '',
      invoiceAddress: '',
      taxIdentity: '',
      invoiceMailAddress: '',
      iban: '',
      bankName: '',
      active: true,
    },
    errorList: [],
    dialog: false,
  }),
  computed: mapGetters([
    'segmentList',
    'showSegmentStatusReason',
    'allCompanyStatus',
    'allCompanyStatusReasonTypes',
  ]),
  created() {
    this.getCompanySegments()
    this.getCompanyStatus()
    this.getCompanyStatusReasonType()
  },
  methods: {
    ...mapActions([
      'addCompany',
      'getCompanySegments',
      'getCompanyStatus',
      'getCompanyStatusReasonType',
      'setShowSegmentStatusReasonAction',
    ]),
    routeCompanies() {
      this.$router.push('/dashboard/companies')
    },
    companyAdd() {
      if (this.$refs.form.validate()) {
        this.snackbar = true
        console.log('data', this.company)
        this.addCompany(this.company)
          .then((response) => {
            if (response.processStatus == 'Success') {
              this.routeCompanies()
            } else {
              alert(response.friendlyMessage.message)
            }
          })
          .catch((err) => {
            alert(err)
          })
      } else {
        var errors = []
        var x = document.getElementsByClassName('v-messages__message')
        for (var i = 0; i < x.length; i++) errors.push(x[i].innerHTML)

        this.errorList = errors

        this.dialog = true
      }
    },
    onCompanyStatusChange(data) {
      const status = this.allCompanyStatus.find(
        (status) => status.value === data,
      )
      if (status.value === 'Closed') {
        this.setShowSegmentStatusReasonAction(true)
      } else {
        this.setShowSegmentStatusReasonAction(false)
      }
    },
  },
}
</script>
